import Content from "uxp-documentation/src/pages/uxp-api/reference-css/Styles/top";
import * as React from 'react';
export default {
  Content,
  React
};